import { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ShopifyRegion } from "../ShopifyGeoSpatialDashboard.data";
import { useLanguage } from "src/hooks/UseLanguage";
import {
  type PakistanShapeKey,
  geoNumberText,
} from "./ShopifyGeoSpatialDashboard.utils";
import "../../../styles/ShopifyGeoPakistanCitiesMap.scss";

const ShopifyGeoCityMapFallback: FC<{ shapeKey: PakistanShapeKey; cities: ShopifyRegion["cities"] }> = ({
  shapeKey,
  cities,
}) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  return (
  <div className="shopify-geo__city-map" role="img" aria-label={t("shopifyGeo.cityMap.fallbackAria")}>
    <div className={`shopify-geo__blob shopify-geo__blob--${shapeKey}`} />
    {cities.length > 0 ? (
      cities.slice(0, 3).map((c, i) => {
        const sizeClass = i === 0 ? "lg" : i === 1 ? "md" : "sm";
        const title = t("shopifyGeo.cityMap.bubbleTitle", {
          city: c.city,
          amount: c.net_revenueFormattedValue
            ?? geoNumberText(c.net_revenue.toLocaleString(), isRTL),
        });
        const label = `${title} — ${t("shopifyGeo.tooltips.formulaTitle")}: ${t("shopifyGeo.tooltips.cityTotalSalesFormula")}`;
        return (
          <span
            key={c.city}
            className={`shopify-geo__bubble shopify-geo__bubble--${sizeClass}`}
            title={label}
            aria-label={label}
          />
        );
      })
    ) : (
      <>
        <span className="shopify-geo__bubble shopify-geo__bubble--lg" />
        <span className="shopify-geo__bubble shopify-geo__bubble--md" />
        <span className="shopify-geo__bubble shopify-geo__bubble--sm" />
      </>
    )}
  </div>
  );
};

export default ShopifyGeoCityMapFallback;
